module.exports = __webpack_public_path__ + "img/img-11.19178a81.jpg";